<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.peduncatr_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos
              <i class="fa fa-doc"></i>
            </span>
          </a>
        </li>
        <li
          class="nav-item"
          v-if="
            rowData.pedido_unidade_carga_trecho_audit != null &&
            rowData.pedido_unidade_carga_trecho_audit.doc_transp
              .doc_transp_doc_ant.length > 0
          "
        >
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.peduncatr_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos Anteriores
              <i class="fa fa-building"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.peduncatr_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 25%">Numero Fiscal</th>
                <th style="width: 25%">Serie</th>
                <th style="width: 25%">Cahve de acesso</th>
                <th style="width: 15%">Data de Emissão</th>
                <th style="width: 10%">Valor Total da NF</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.pedido_unidade_carga_trecho_audit
                  .doc_transp.doc_transp_doc_carga"
              >
                <td>
                  {{ item.num_nf }}
                </td>
                <td>
                  {{ item.serie }}
                </td>
                <td>
                  {{ item.chave }}
                </td>
                <td>
                  <span> {{ DateFormat(item.dt_emi) }} </span>
                </td>
                <td>
                  {{ item.vlr_total_nf }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t2' + rowData.peduncatr_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 100%">Chave</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.pedido_unidade_carga_trecho_audit
                  .doc_transp.doc_transp_doc_ant"
              >
                <td>
                  {{ item.doc_transp_doc_ant_eletr[i].chave }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      helpForm: new Form({ recordCollection: [], status: "" }),
      cnpj_formatado: "",
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onEditDoc(data) {
      this.$refs.vinculardocumentounidadeform.onEdit(data);
    },
    onEditConta(data) {
      this.$refs.vincularcontaunidadeform.onEdit(data);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
  },
};
</script>